import styles from './styles.module.scss';

const AiAnalyticsIcon = () => {
  return (
    <div
      className={styles.aiAnalyticsIcon}
    >
      AI
    </div>
  );
};

export default AiAnalyticsIcon;
